import { EObcanstviDruhDokladu } from 'types/amlz';

import { EStavZadostAmlz } from 'services/spravaEmitenta/historickeZadosti';
import { EZadostPravoIdentifikace } from 'services/spravaEmitenta/zadostPravo';

import { EPristupDepozitar } from 'enums/amlz/pristupDepozitar';
import { EZastupujeOsoba } from 'enums/amlz/zastupujeOsoba';

export const druhdokladuSelect = [
    {
        labelcz: 'OBCANSTVI_DOKLAD_OBCANKA',
        value: EObcanstviDruhDokladu.OBCANKA
    },
    {
        labelcz: 'OBCANSTVI_DOKLAD_PAS',
        value: EObcanstviDruhDokladu.PAS
    },
    {
        labelcz: 'OBCANSTVI_DOKLAD_RIDICAK',
        value: EObcanstviDruhDokladu.RIDICAK
    },
    {
        labelcz: 'OBCANSTVI_DOKLAD_JINE',
        value: EObcanstviDruhDokladu.JINE
    }
];
export const identifikaceOsobySelect = [
    {
        labelcz: 'ZADOST_PRAVO_IDENTIFIKACE_EL',
        value: EZadostPravoIdentifikace.EL
    },
    {
        labelcz: 'ZADOST_PRAVO_IDENTIFIKACE_BI',
        value: EZadostPravoIdentifikace.BI
    },
    {
        labelcz: 'ZADOST_PRAVO_IDENTIFIKACE_SC',
        value: EZadostPravoIdentifikace.SC
    }
];
export const zastupujeOsobaSelect = [
    {
        value: EZastupujeOsoba.FYZOSOBA_VYPIS,
        labelcz: 'ISIN_ZASTUPUJE_OSOBA_FODVR'
    },
    {
        value: EZastupujeOsoba.FYZOSOBA_PLNAMOC,
        labelcz: 'ISIN_ZASTUPUJE_OSOBA_FOZPM'
    },
    {
        value: EZastupujeOsoba.FYZOSOBA_JINEOPRAV,
        labelcz: 'ISIN_ZASTUPUJE_OSOBA_FOZJO'
    }
];
export const authSelect = [
    {
        labelcz: 'TYP_PRIHLASENI_PXKL',
        value: 'PXKLIC'
    },
    {
        labelcz: 'TYP_PRIHLASENI_CERT',
        value: 'CERT'
    },
    {
        labelcz: 'TYP_PRIHLASENI_BANKID',
        value: 'BI'
    }
];
export const authSelectAlt = [
    {
        labelcz: 'TYP_PRIHLASENI_PXKL',
        value: 'PXKLIC'
    },
    {
        labelcz: 'TYP_PRIHLASENI_CERT',
        value: 'CERT'
    }
];
export const pristupdepozitarSelect = [
    {
        labelcz: 'PRISTUPDEPOZITAR_ANO',
        value: EPristupDepozitar.ANO
    },
    {
        labelcz: 'PRISTUPDEPOZITAR_NE',
        value: EPristupDepozitar.NE
    },
    {
        labelcz: 'PRISTUPDEPOZITAR_POZDEJI',
        value: EPristupDepozitar.POZDEJI
    }
];
export const c2stavSelectROZP = [
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.ROZP,
        value: EStavZadostAmlz.ROZP
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_UZIVEMAIL_ALT',
        value: EStavZadostAmlz.UZIVEMAIL
    }
];
export const c2stavSelectDOPL = [
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.ROZP,
        value: EStavZadostAmlz.ROZP
    },
    /* {
        labelcz: 'STAVZADOSTI_SIMPLE_UZIVEMAIL_ALT',
        value: EStavZadostAmlz.UZIVEMAIL
    }, */
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.CDCPKEKONTR,
        value: EStavZadostAmlz.CDCPKEKONTR
    }
];
export const c2stavSelectUZIVCEKA = [
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.UZIVCEKA,
        value: EStavZadostAmlz.UZIVCEKA
    }
    /*  {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.UZIVEMAIL,
        value: EStavZadostAmlz.UZIVEMAIL
    } */
];
export const c2stavSelectUZIVDOPL = [
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.UZIVDOPL,
        value: EStavZadostAmlz.UZIVDOPL
    },
    /*  {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.UZIVEMAIL,
        value: EStavZadostAmlz.UZIVEMAIL
    }, */
    {
        labelcz: 'STAVZADOSTI_SIMPLE_CDCPKEKONTR_ALT',
        value: EStavZadostAmlz.CDCPKONTR
    }
];
export const c2stavSelectUZIVDOPLAMLZ = [
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.UZIVDOPL,
        value: EStavZadostAmlz.UZIVDOPL
    },
    /* {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.UZIVEMAIL,
        value: EStavZadostAmlz.UZIVEMAIL
    }, */
    {
        labelcz: 'STAVZADOSTI_SIMPLE_HOTOVO',
        value: EStavZadostAmlz.HOTOVO
    }
];
export const c2stavSelect = [
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.ROZP,
        value: EStavZadostAmlz.ROZP
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_' + EStavZadostAmlz.HOTOVO,
        value: EStavZadostAmlz.HOTOVO
    }
];
export const c2stavSelectALL = [
    {
        labelcz: 'STAVZADOSTI_SIMPLE_ROZP',
        value: EStavZadostAmlz.ROZP
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_DOPL',
        value: EStavZadostAmlz.DOPL
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_UZIVCEKA',
        value: EStavZadostAmlz.UZIVCEKA
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_UZIVDOPL',
        value: EStavZadostAmlz.UZIVDOPL
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_CDCPKEKONTR_ALT',
        value: EStavZadostAmlz.CDCPKEKONTR
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_CDCPKONTR',
        value: EStavZadostAmlz.CDCPKONTR
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_CDCPKDOPL',
        value: EStavZadostAmlz.CDCPKDOPL
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_INI',
        value: EStavZadostAmlz.INI
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_HOTOVO',
        value: EStavZadostAmlz.HOTOVO
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_UZIVEMAIL',
        value: EStavZadostAmlz.UZIVEMAIL
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_ODEBRAT',
        value: EStavZadostAmlz.ODEBRAT
    },
    {
        labelcz: 'STAVZADOSTI_SIMPLE_PRIDAT',
        value: EStavZadostAmlz.PRIDAT
    }
];
